import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ViewContainerRef,
    OnInit,
    AfterViewInit,
    OnDestroy
} from '@angular/core';

import { Subject, BehaviorSubject, timer } from 'rxjs';
import { switchMap, map, tap, filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'toastr-toast',
    templateUrl: './toast.component.pug',
    styleUrls: ['./toast.component.less'],
})
export class ToastComponent implements AfterViewInit, OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @ViewChild('content', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

    @Input() actions: boolean = true;

    _startTimeSbj: BehaviorSubject<number> = new BehaviorSubject(null);
    _timeoutSbj: BehaviorSubject<number> = new BehaviorSubject(null);
    @Input() set timeout(timeout: number) {
        this._startTimeSbj.next(new Date() .getTime());
        this._timeoutSbj.next(timeout);
    };
    get timeout(): number {
        return this._timeoutSbj.getValue();
    }

    @Output() close: EventEmitter<void> = new EventEmitter();

    timeleft$ = this._timeoutSbj.asObservable()
        .pipe(takeUntil(this._destroySbj))
        .pipe(filter((timeout) => !!timeout))
        .pipe(map(() => new Date() .getTime()))
        .pipe(switchMap((startTime) => timer(0, 10).pipe(map(() => startTime))))
        .pipe(map((startTime) => new Date() .getTime() - startTime));

    progress$ = this.timeleft$
        .pipe(map((v) => 100 - (v / this.timeout * 100)))
        .pipe(map((v) => `${ v }%`));

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.timeleft$
            .pipe(takeUntil(this._destroySbj))
            .pipe(filter((v) => v > this.timeout))
            .pipe(tap(() => this.onClose()))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    onClose() {
        this._destroySbj.next();
        this.close.emit();
    }
}
